import apolloClient from "../apolloClient";
import { GET_PAYMENT_METHODS } from "./graphql";

class PaymentMethodService {
	async list() {
		const { data } = await apolloClient.query({
			query: GET_PAYMENT_METHODS,
		});

		return data.customerPaymentMethods.nodes;
	}
}

export default new PaymentMethodService();
